import { DonationFormShell, UpsellModule } from '@web/components/page-components/DonationForm'
import { DonationForm as DonationFormProps } from '@web/graphql-components'
import { DonationFormStep1 } from './DonationFormStep1'
import StripeWrapper from './StripeWrapper'
import DonationFormFinalStep from './DonationFormFinalStep'
import DonationFormErrorStep from './DonationFormErrorStep'
import { useMemo } from 'react'
import React from 'react'
import { QUICK_PAY_PAYMENT_METHOD_TYPES, usePaymentStore } from 'apps/fe-donation/libs/hooks/usePaymentStore'
import DonationFieldsStep from './ThreeStepForm/DonationFieldsStep'
import DonationPaymentStep from './ThreeStepForm/DonationPaymentStep'
import environment from 'apps/fe-donation/libs/environment'
import DonationPostContactStep from './DonationFormPostContactStep'
import DonationCheckoutForm from './DonationCheckoutForm'
import { UpsellModuleHeader } from '@web/components/page-components/DonationForm/components/UpsellModule'

const DonationForm = (props: DonationFormProps) => {
  const paymentMethodType = usePaymentStore((state) => state.paymentMethodType)
  const isQuickPay = paymentMethodType && QUICK_PAY_PAYMENT_METHOD_TYPES.includes(paymentMethodType)
  const steps = useMemo(() => {
    if (props.styles?.steps === 3) {
      return [
        <DonationFormStep1 key="step-1" {...props} withPayment={false} />,
        <DonationFieldsStep key="step-2" />,
        <DonationPaymentStep key="step-3" />,
        ...(isQuickPay
          ? [<DonationFormFinalStep key="step-4" {...props} />]
          : [
              <StripeWrapper key="step-4" paymentMethodType={paymentMethodType}>
                <DonationCheckoutForm {...props} paymentMethodType={paymentMethodType!} />
              </StripeWrapper>,
              <DonationFormFinalStep key="step-5" {...props} />,
            ]),
      ]
    }

    return [
      <DonationFormStep1 key="step-1" {...props} />,
      ...(isQuickPay
        ? [<DonationFormFinalStep key="step-2" {...props} />]
        : [
            <StripeWrapper key="step-2" paymentMethodType={paymentMethodType}>
              <DonationCheckoutForm {...props} paymentMethodType={paymentMethodType!} />
            </StripeWrapper>,
            <DonationFormFinalStep key="step-3" {...props} />,
          ]),
    ]
  }, [isQuickPay])

  return (
    <DonationFormShell
      donationFormProps={props}
      googleMapsApiKey={environment.googleMapsApiKey}
      steps={[
        ...steps,
        ...(props.styles?.options?.upsellRegularGivingOptions
          ? [
              <UpsellModule key="upsell-step">
                <UpsellModuleHeader />
              </UpsellModule>,
              <React.Fragment key="spacer" />, // because call us form takes a spot we need this here
              // TODO: Rejig this logic
            ]
          : []),
        ...(props.styles?.options?.hasCallUsForm ? [<DonationPostContactStep key="contact-step" />] : []),
        <DonationFormErrorStep key="error-step" {...props} />,
      ]}
    />
  )
}

export default DonationForm
